import { FieldErrors, FieldValues } from "react-hook-form";
import { TAlertMessage } from "../components/elements/alert-summary/alert-summary";
import { TFunction } from "i18next";

export type FieldLabelsByName<T extends FieldValues> = {
  [key in keyof T]: string;
};

export const getErrorsFromHookFormError = <T extends FieldValues>(
  fieldErrors: FieldErrors<T>,
  fieldLabelsByName: Record<keyof T, string>,
  t: TFunction,
) => {
  const errors: Array<TAlertMessage> = [];
  if (!fieldErrors) {
    return errors;
  }

  for (const [key, value] of Object.entries(fieldErrors)) {
    const fieldLabel = fieldLabelsByName[key];
    if (value?.message && typeof value?.message === "string") {
      errors.push({
        text: `${fieldLabel}: ${value.message}`,
      });
    } else if (value?.type === "required") {
      errors.push({
        text: `${fieldLabel}: ${t("INPUT_FIELD_REQUIRED")}`,
      });
    }
  }

  return errors;
};
